import { toast } from "react-toastify";

export function successToast(msg) {
  toast.success(msg, {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "colored",
  });
}
export function errorToast(msg) {
  toast.error(<div dangerouslySetInnerHTML={{ __html: msg }} />, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "colored",
  });
}
export function errorHandling(msg) {
  if (
    msg === "Authentication credentials were not provided." ||
    msg === "Signature has expired."
  ) {
    window.location.href = "/auth?isTokenExpired=true";
  }
  return;
}

export function dataHandling(response) {
  var data = response.json();
  if (response.status === 200 || response.status === 201) {
    if (
      data["message"] !== null &&
      data["message"] !== undefined &&
      data["message"] !== ""
    ) {
      successToast(data["message"]);
    }

    return { status: true, data: data["result"] };
  } else {
    errorHandling(data["message"]);
    errorToast(data["message"]);
    return { status: false, data: data };
  }
}
